/**
 * @ Author: DY
 * @ Date: 2022-06-22 15:05:28
 * @ LastEditTime: 2022-09-21 16:00:49
 * @ Description:
 * @ FilePath: \BusinessPlatform\src\router\index.js
 */
import Vue from 'vue';
import Router from 'vue-router';
import menuJson from '@/router/menuJson';

Vue.use(Router);

const createRouter = () =>
    new Router({
        routes: menuJson.commonRoutes,
        mode: 'history',
    });

const router = createRouter();

router.beforeEach((to, from, next) => {
    // 处理无界子应用路由
    if (to.query.wujieContent) {
        // 修复路径格式（防止双斜杠）
        const cleanPath = decodeURIComponent(to.query.wujieContent).replace(/\/+/g, '/');
        if (cleanPath !== to.query.wujieContent) {
            next({
                ...to,
                query: {
                    ...to.query,
                    wujieContent: encodeURIComponent(cleanPath)
                },
                replace: true,
            });
            return;
        }
    }
    // 页面刷新时恢复子应用路由 - 只在没有wujieContent参数时处理
    if (to.path === '/wujie/instant-sticker' && !to.query.wujieContent) {
        const savedRoute = sessionStorage.getItem('wujieChildRoute');
        if (savedRoute && savedRoute !== '/') {
            next({
                path: '/wujie/instant-sticker',
                query: {
                    wujieContent: encodeURIComponent(savedRoute),
                },
                replace: true,
            });
            return;
        }
    }
    next();
});

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;
